/**
 * GelatoMaps — Main Entry Point (Vite)
 * Loads global styles and bootstraps the module system.
 */

// Global styles
import './shared/styles/tokens.css'
import './shared/styles/components.css'

// Bootstrap the app
import { bootstrap } from './bootstrap.js'

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap)
} else {
  bootstrap()
}
